// Server variables & status client (admin). Per-connection raw SHOW GLOBAL
// VARIABLES / STATUS + editing a dynamic global variable (SET GLOBAL, or
// SET PERSIST on MySQL 8.0+).
import { api } from './api.js';

export const getServerVariables = (connId) =>
  api.get(`/api/connections/${connId}/server-variables`);

export const getServerStatus = (connId) =>
  api.get(`/api/connections/${connId}/server-status`);

// body: { name, value, persist }
export const setServerVariable = (connId, body) =>
  api.post(`/api/connections/${connId}/server-variables`, body);

// Managed "keep across restarts" rules — for servers without native SET PERSIST.
// A rule applies SET GLOBAL now and is re-applied by the backend reconciler after
// a detected restart.
export const getManagedVariables = (connId) =>
  api.get(`/api/connections/${connId}/managed-variables`);

// body: { name, value } — applies SET GLOBAL now + creates/updates the rule.
export const setManagedVariable = (connId, body) =>
  api.post(`/api/connections/${connId}/managed-variables`, body);

export const deleteManagedVariable = (connId, name) =>
  api.delete(`/api/connections/${connId}/managed-variables/${encodeURIComponent(name)}`);
